module.exports = __webpack_public_path__ + "static/img/M7.efca881f.png";